<template>
    <DModal
        :show="showModal"
        :title="__(`tools.direct_admin.error_modal.errors`)"
        @close="closeModal"
    >
        <DCard padding>
            <ul class="ul-class">
                <li
                    v-for="({ message, source }, index) in errors"
                    :key="index"
                    class="pb-2 pl-0"
                >
                    <strong>{{ __(`tools.direct_admin.error_modal.error_source.${source}`) }}:</strong> {{ message }}
                </li>
            </ul>
        </DCard>
    </DModal>
</template>

<script setup>

defineProps({
    showModal: {
        type: Boolean,
        default: false
    },
    errors: {
        type: Array,
        default: () => { return [] }
    }
})

const emit = defineEmits(['close-modal'])

const closeModal = () => {
    emit('close-modal')
}
</script>

<style lang="scss" scoped>
.ul-class{
    padding-left: 20px;
}
</style>
